import React from 'react';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { tB } from '../../translate';
import Style from './m_styles.less';

interface IShowBooleanField {
    field?: boolean | string;
    isColor?: boolean;
}

export const booleanYNText = (val?: boolean | string): string => {
    return tB(val ? 'Yes' : 'No');
};
export const booleanEDText = (val?: boolean | string): string => {
    return tB(val ? 'Enabled' : 'Disabled');
};

export const ShowBooleanYNField: React.FC<IShowBooleanField> = ({ field, isColor }: IShowBooleanField) => {
    return (
        <span className={isColor ? (field ? Style.booleanFieldColorTrue : Style.booleanFieldColorFalse) : undefined}>
            {booleanYNText(field)}
        </span>
    );
};
export const ShowBooleanEDField: React.FC<IShowBooleanField> = ({ field, isColor }: IShowBooleanField) => {
    return (
        <span className={isColor ? (field ? Style.booleanFieldColorTrue : Style.booleanFieldColorFalse) : undefined}>
            {booleanEDText(field)}
        </span>
    );
};
export const ShowBooleanFieldIcon: React.FC<IShowBooleanField> = ({ field, isColor = true }: IShowBooleanField) => {
    return (
        <span className={isColor ? (field ? Style.booleanFieldColorTrue : Style.booleanFieldColorFalse) : undefined}>
            {field ? <CheckOutlined /> : <CloseOutlined />}
        </span>
    );
};
